import { Injectable } from '@angular/core';
import { Init } from './init';

@Injectable()
export class ApiService extends Init {

    constructor() {
        super();
        console.log('ApiService Works');
        this.load(null, []);
    }

    get(name: string) {
        return JSON.parse(localStorage.getItem(name));
    }

    addAll(name: string, newData: string) {
        const data = JSON.parse(localStorage.getItem(name)) || [];
        // Add New data
        data?.push(newData);
        // Set New data
        localStorage.setItem(name, JSON.stringify(data));
    }

    addOnlyOneString(name: string, newData: string) {
        let data = JSON.parse(localStorage.getItem(name));
        if (data && data !== newData) { data = newData; }
        // Set New data
        localStorage.setItem(name, JSON.stringify(data));
    }

    delete(name: string, id: string) {
        const data: string[] = JSON.parse(localStorage.getItem(name));
        data?.forEach((element: any, index) => {
            if (element?.id === id) { data.splice(index, 1); }
        });
        // Set New data
        localStorage.setItem(name, JSON.stringify(data));
    }

    update(name: string, id: string, newData: string) {
        const data = JSON.parse(localStorage.getItem(name));

        data?.forEach((element: any, index) => {
            if (element?.id === id) { data[index] = newData; }
        });

        // Set New data
        localStorage.setItem(name, JSON.stringify(data));
    }
}
